(function (window, document) {
  if (window.boatWidget) {
    console.error("Boat widget embed already included");
    return;
  }
  var m = ["init"];
  window.boatWidget = {};
  window.boatWidget._c = [];

  // Host pages bust this snippet's cache with a query string; carry it to the shim so both stay in sync.
  var snippetSrc = (document.currentScript && document.currentScript.src) || "";
  var queryIndex = snippetSrc.indexOf("?");
  var versionQuery = queryIndex === -1 ? "" : snippetSrc.slice(queryIndex);

  m.forEach(
    (me) =>
      (window.boatWidget[me] = function () {
        window.boatWidget._c.push([me, arguments]);

        if (me === "init") {
          var elt = document.createElement("script");
          elt.type = "text/javascript";
          elt.async = true;
          elt.src = arguments[0].apiUrl + "/build/frontend/widget/shim.js" + versionQuery;
          var before = document.getElementsByTagName("script")[0];
          before.parentNode.insertBefore(elt, before);
        }
      })
  );
})(window, document, undefined);

